import { CirclePause } from 'lucide-react';
import styled from 'styled-components';
import { Button } from 'components/buttons';
import {
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogTitle,
} from 'components/dialog/dialog';

export const StopDialogContent = styled(DialogContent).attrs({
  className: 'max-w-[420px] gap-4 rounded-md p-4 sm:max-w-[420px]',
})``;

export const StopDialogTitle = styled(DialogTitle).attrs({
  className: 'pr-6 text-base',
})``;

export const StopDialogDescription = styled(DialogDescription).attrs({
  className: 'leading-5 text-foreground',
})``;

export const StopDialogFooter = styled(DialogFooter).attrs({
  className: 'flex-row justify-end pt-4',
})``;

export const CancelStopButton = styled(Button).attrs({
  variant: 'outline',
  size: 'sm',
  className: 'border-primary bg-white text-primary hover:bg-vantis-silver hover:text-primary',
})``;

export const ConfirmStopButton = styled(Button).attrs({
  size: 'sm',
})``;

export const ConfirmStopIcon = styled(CirclePause).attrs({
  className: 'size-4',
  'aria-hidden': true,
})``;
